import React from "react"
import Footer from "../components/footer"
import Navbar from "../components/nav"

function AiImageDetectionTerms() {
    return (
        <>
            <header className="header-area">
                <div className="navbar-area">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <Navbar />
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <div id="home">
                <div className="container mt-125 mb-50">
                    <div className="card-body shadow">
                        <h4>Terms & Conditions - AI Image Detector</h4>
                        <br />
                        <ul>
                            <li>THE DEVELOPER = MWX Apps</li>
                            <li>THE APP = AI Image Detector - Fake Check</li>
                        </ul>
                        <br />
                        <p>
                            By downloading or using THE APP, these terms will automatically apply
                            to you – you should make sure therefore that you read them carefully
                            before using THE APP. You're not allowed to copy, or modify THE APP,
                            any part of THE APP, or our trademarks in any way. You're not allowed
                            to attempt to extract the source code of THE APP, and you also
                            shouldn't try to translate THE APP into other languages, or make
                            derivative versions. THE APP itself, and all the trade marks,
                            copyright, database rights and other intellectual property rights
                            related to it, still belong to THE DEVELOPER.
                        </p>
                        <p>
                            THE DEVELOPER is committed to ensuring that THE APP is as useful and
                            efficient as possible. For that reason, we reserve the right to make
                            changes to THE APP or to charge for its services, at any time and for
                            any reason. We will never charge you for THE APP or its services
                            without making it very clear to you exactly what you're paying for.
                        </p>

                        <br />
                        <strong>Offline Functionality</strong>
                        <p>
                            THE APP is designed to work 100% offline. All image analysis and AI
                            detection is performed locally on your device. No internet connection
                            is required for the core functionality of THE APP. Your images are
                            never uploaded to any external servers.
                        </p>

                        <br />
                        <strong>Device Security</strong>
                        <p>
                            It's your responsibility to keep your phone and access to THE APP
                            secure. We therefore recommend that you do not jailbreak or root your
                            phone, which is the process of removing software restrictions and
                            limitations imposed by the official operating system of your device.
                            It could make your phone vulnerable to malware/viruses/malicious
                            programs, compromise your phone's security features and it could mean
                            that THE APP won't work properly or at all.
                        </p>

                        <br />
                        <strong>AI Detection Accuracy</strong>
                        <p>
                            THE APP uses machine learning models to detect AI-generated images.
                            While we strive for high accuracy, THE DEVELOPER cannot guarantee
                            100% accuracy in all cases. The detection results should be used as
                            a guide and not as definitive proof. THE DEVELOPER accepts no
                            liability for any decisions made based on the analysis results
                            provided by THE APP.
                        </p>

                        <br />
                        <strong>Limitation of Liability</strong>
                        <p>
                            With respect to THE DEVELOPER's responsibility for your use of THE APP,
                            when you're using THE APP, it's important to bear in mind that although
                            we endeavour to ensure that it is updated and correct at all times,
                            THE DEVELOPER accepts no liability for any loss, direct or indirect,
                            you experience as a result of relying wholly on this functionality of
                            THE APP.
                        </p>

                        <br />
                        <strong>Updates</strong>
                        <p>
                            At some point, we may wish to update THE APP. THE APP is currently
                            available on Android – the requirements for system (and for any
                            additional systems we decide to extend the availability of THE APP to)
                            may change, and you'll need to download the updates if you want to keep
                            using THE APP. THE DEVELOPER does not promise that it will always
                            update THE APP so that it is relevant to you and/or works with the
                            Android version that you have installed on your device. However, you
                            promise to always accept updates to THE APP when offered to you. We may
                            also wish to stop providing THE APP, and may terminate use of it at any
                            time without giving notice of termination to you. Unless we tell you
                            otherwise, upon any termination, (a) the rights and licenses granted to
                            you in these terms will end; (b) you must stop using THE APP, and (if
                            needed) delete it from your device.
                        </p>

                        <br />
                        <strong id="changes-to-these-terms-and-conditions">
                            <a
                                aria-hidden="true"
                                href="#changes-to-these-terms-and-conditions"
                                tabindex="-1"
                            >
                                <span class="icon icon-link"></span>
                            </a>
                            Changes to These Terms and Conditions
                        </strong>
                        <p>
                            We may update our Terms and Conditions from time to time. Thus, you are
                            advised to review this page periodically for any changes. These changes
                            are effective immediately after they are posted on this page.
                        </p>

                        <br />
                        <strong id="contact-us">
                            <a aria-hidden="true" href="#contact-us" tabindex="-1">
                                <span class="icon icon-link"></span>
                            </a>
                            Contact Us
                        </strong>
                        <p>
                            If you have any questions or suggestions about these Terms and
                            Conditions, do not hesitate to contact us at: mwxapps@gmail.com
                        </p>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}

export default AiImageDetectionTerms
